import React from 'react';
import SavedAddressSection from '../components/SavedAddressSection';

export const CryptoAddressPage = () => {
    return (
        <div className="bg-[#F4F4F5] dark:bg-[#18181B]">
            <SavedAddressSection />
        </div>
    );
};
